/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import customModal from "../customModal/customModal.vue";
export default {
    components: {
        customModal,
        VPagination
    },
    data() {
        return {
            selectedPanel: null,
            baseUrl: `${process.env.VUE_APP_Service_URL}/management/statusmaster/`,
            baseapi: process.env.VUE_APP_Service_URL,
            statusPanels: [],
            tableData: {
                study: [],
                form: [],
                visit: [],
                site: [],
                subject: [],
                alert: []
            },
            showCreateStatusModal: false,
            showCreateStatusTypeModal: false,
            isEditStatusTypeMode: false,
            statusTypeError: '',
            statusLabelError: '',
            newStatus: {
                statusId: null,
                statusType: '',
                status: '',
                colorCode: '#000000',
                active: true,
                description: ''
            },
            showSideModal: {},
            newStatusType: {
                name: '',         
                type: '',         
                description: '',
                active: true
            },
            isEditMode: false,
            editingId: null,
            statusError: "",
            currentPage: 1,
            pageindex: 1,
            pagesize: 10,
            totalPage: 1,
            SortProperty: "CreatedAt",
            SortOrder: false,

        };
    },
    mounted() {
        this.loadStatusPanels();
    },
    methods: {
        async loadStatusPanels() {
            const idtoken = store.getters.getIdToken;

            try {
                const response = await axios.get(
                    `${this.baseUrl}getallstatustypes`,
                    // `https://localhost:5001/statusmaster/getallstatustypes`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const types = response.data;

                this.statusPanels = types.map(x => ({
                    key: x.statusType,
                    label: x.statusTypeName,
                    id: x.id
                }))
                 .sort((a, b) => a.label.localeCompare(b.label));

                // Optionally select first panel and load data
                // if (this.statusPanels.length > 0) {
                //     this.selectPanel(this.statusPanels[0].key);
                // }

            } catch (err) {
                console.error('Error loading status types:', err);
            }
        },
        selectPanel(key) {
            this.selectedPanel = key;
            this.fetchStatusMaster(key);
        },
        SortSelected(property) {
            if (this.SortProperty === property) {

                this.SortOrder = !this.SortOrder;
            } else {
                this.SortProperty = property;
                this.SortOrder = false;
            }
            this.SortOrderInt = this.SortOrder ? 1 : 0;
            this.pageindex = 1;
            this.fetchStatusMaster(this.selectedPanel);
        },


        getPanelLabel(key) {
            const found = this.statusPanels.find(p => p.key === key);
            return found ? found.label + " List" : "";
        },
        openCreateModal() {
            this.newStatus = {
                statusId: null,
                statusType: this.selectedPanel,
                status: '',
                description: '',
                colorCode: '#000000',
                active: true
            };
            this.isEditMode = false;
            this.showCreateStatusModal = true;
        },

        editRow(row) {
            this.newStatus = {
                statusId: row.statusId,
                statusType: this.selectedPanel,
                status: row.status,
                colorCode: row.colorCode,
                active: row.active,
                description: row.description
            };
            this.isEditMode = true;
            this.showCreateStatusModal = true;
        },

        deleteRow(row) {
            if (confirm(`Are you sure to delete ${row.name}?`)) {
                this.tableData[this.selectedPanel] = this.tableData[this.selectedPanel].filter(
                    r => r.name !== row.name
                );
            }
        },
        clearError() {
            this.statusError = "";
        },
        closeModal() {
            this.statusError = "";
            this.showCreateStatusModal = false;
            this.resetForm();
        },
        async submitNewStatus() {
            this.statusError = "";

            if (!this.newStatus.status.trim()) {
                this.statusError = "Status name is required";
                return;
            }
            const idtoken = store.getters.getIdToken;
            const url = this.isEditMode ? `${this.baseUrl}update` : `${this.baseUrl}create`;

            try {
                if (this.isEditMode) {
                    await axios.put(url, this.newStatus, {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    });
                } else {
                    await axios.post(url, this.newStatus, {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    });
                }

                this.fetchStatusMaster(this.selectedPanel);
                const message = this.isEditMode ? "Status updated successfully" : "Status created successfully";
                alert(message);

                this.resetForm();
            } catch (error) {
                console.error("Failed to submit status:", error);
                const errorMessage =
                    error.response?.data?.errors?.DomainValidations?.[0] ||
                    error.response?.data?.detail ||
                    "Something went wrong while saving status.";

                alert(errorMessage);
            }
        },
        async fetchStatusMaster(statusType) {
            const idtoken = store.getters.getIdToken;

            try {
                const response = await axios.get(
                    `${this.baseUrl}listallstatus`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                        params: {
                            statusType: statusType,
                            pageindex: this.pageindex,
                            pagesize: this.pagesize,
                            sortProperty: this.SortProperty || "CreatedAt",
                            sortOrder: this.SortOrderInt,
                        }
                    }
                );

                this.tableData = response.data.data;
                this.totalPage = Math.ceil(response.data.totalCount / this.pagesize);
            } catch (err) {
                console.error(`Error loading ${statusType} status data:`, err);
                this.tableData = [];
            }
        },

        resetForm() {
            this.newStatus = {
                statusType: '',
                status: '',
                description: '',
                colorCode: '#000000',
                active: true
            };
            this.isEditMode = false;
            this.editingId = null;
            this.showCreateStatusModal = false;
        },
        loadPage(page) {
            this.currentPage = page;
            this.pageindex = page;
            this.fetchStatusMaster(this.selectedPanel);
        },



        async deleteRow(row) {
            const idtoken = store.getters.getIdToken;

            if (!confirm(`Are you sure you want to delete "${row.status}"?`)) return;

            try {
                await axios.delete(`${this.baseUrl}delete?id=${row.statusId}`, {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json"
                    }
                });
                alert("Status deleted successfully");
                this.fetchStatusMaster(this.selectedPanel);

            } catch (error) {
                console.error("Failed to delete status:", error);
            }
        },
        openStatusTypeModal(editMode = false, existing = null) {
            this.isEditStatusTypeMode = editMode;
            if (editMode && existing) {
                this.newStatusType = { ...existing };
            } else {
                this.newStatusType = { name: '', description: '', active: true };
            }
            this.statusTypeError = '';
            this.statusLabelError = '';
            this.showCreateStatusTypeModal = true;
        },
        closeStatusTypeModal() {
            this.showCreateStatusTypeModal = false;
        },
        clearStatusTypeError() {
            this.statusTypeError = '';
        },
        clearStatusLabelError() {
            this.statusLabelError = '';
        },
        async submitNewStatusType() {
            const idtoken = store.getters.getIdToken;
            let hasError = false;

            if (!this.newStatusType.name) {
                this.statusLabelError = "Status label is required";
                hasError = true;
            }

            if (!this.newStatusType.type) {
                this.statusTypeError = "Status type is required";
                hasError = true;
            }

            if (hasError) return;

            const payload = {
                statusName: this.newStatusType.name,
                statusType: this.newStatusType.type,
                description: this.newStatusType.description,
                active: this.newStatusType.active
            };

            try {
                const response = await axios.post(
                    `${this.baseUrl}createstatustype`,
                    payload,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json"
                        }
                    }
                );

                window.alert("Status type created successfully");
                this.closeStatusTypeModal();
                this.loadStatusPanels();

            } catch (err) {
                console.error("Error creating status type:", err);

                const errorMessage =
                    err.response?.data?.errors?.DomainValidations?.[0] ||
                    err.response?.data?.detail ||
                    "Something went wrong";

                window.alert(errorMessage);
            }
        },
        async deleteStatusType(item, index) {
            console.log("Deleting status type with ID:", item.id);
            if (!confirm(`Are you sure you want to delete "${item.label}"?`)) return;

            const idtoken = store.getters.getIdToken;
            try {
                await axios.delete(`${this.baseUrl}deletestatustype?id=${item.id}`, {
                    headers: { Authorization: 'Bearer ' + idtoken }
                });

                alert(`${item.label} deleted successfully`);
                 this.loadStatusPanels();
                this.showSideModal = {};
            } catch (err) {
                console.error('Delete failed:', err);

            }
        }




    }
};